module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/team-development-calendar/team-development-calendar.component.html
// module id = ./src/app/pages/team-development-calendar/team-development-calendar.component.html
// module chunks = main